import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NO_DATA_LANG_LABEL } from '../../constants/ads';
import { GOAL_TYPE } from '../../constants/goals';

const NO_DATA_DISPLAY = /*#__PURE__*/_jsx(FormattedMessage, {
  message: NO_DATA_LANG_LABEL
});

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export default function GoalTypePerCampaignValue({
  goalTypeData,
  goalType
}) {
  if (!isNumeric(goalTypeData.value)) {
    return NO_DATA_DISPLAY;
  }

  if (goalType === GOAL_TYPE.COST_PER_CONTACT_IN_LIFECYCLE) {
    return /*#__PURE__*/_jsx(FormattedCurrency, {
      currencyCode: goalTypeData.format,
      value: goalTypeData.value || 0
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: goalTypeData.value
  });
}